import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import search from '../assets/search.png';
import sumaBlanco from '../assets/sumaBlanco.png';
import BtnGuardarEdit from './BtnGuardarEdit';
import FormInput from './FormInput';
import axios from '../axiosConfig';
import { handleError, toastError } from '../funciones';
import { ButtonAdmin } from './ButtonAdmin';


function EncabezadoAdminN(props) {
    const [eventos, setEventos] = useState([]);
    const [showUniones, setShowUniones] = useState(true);

    const noShowedModals = props.showedModals.length === 0;
    useEffect(() => {
        if (props.seccion === "crearReunion") {

            axios
                .get(process.env.REACT_APP_URL + 'evento/eventosQueSeanRondasDeNegocios')
                .then(function (response) {
                    setEventos(response.data);
                    response.data.length > 0 && props.setEvento(response.data[0]);

                })
                .catch(function (error) {
                    toastError(handleError(error))
                });
        }
    }, [])

    function verCrear() {
        if (noShowedModals) {
            props.setShowedModals(prev => [...prev, 'create'])
        } else {
            if (!props.showedModals.includes('invited')) {
                if (props.showedModals.includes('create')) {
                    document.getElementById("containerCrearScroll").scroll(0, 0);
                    props.seccion === "crearEvento" && props.setEvento({ nombre: '' })
                } else {
                    document.getElementById("containerInscriptos").scroll(0, 0);
                }
            }
            props.setNombreBuscar('')
            props.setShowedModals(prev => prev.slice(0, -1));
        }
        /*if (document.getElementById("containerInvitados")?.classList.contains("transform-none")) {
            document.getElementById("containerInvitados").classList.remove("transform-none");
        } else {
        if (document.getElementById("btnCrearEvento").classList.contains("bg-color-cerrar")) {
            if (document.getElementById("containerCrear").classList.contains("transform-none")) {
                document.getElementById("containerCrear").classList.remove("transform-none");
                document.getElementById("containerCrearScroll").scroll(0, 0);
                props.setEvento({ nombre: '' })
            } else {
                document.getElementById("containerInscriptos").classList.remove("transform-none");
                document.getElementById("containerInscriptos").scroll(0, 0);
                document.getElementById("buscarText").value = ''
            }
        }
        /* else {
             document.getElementById("containerCrear").classList.add("transform-none");
         }*/
        /*document.getElementById("txt-nuevo-evento").classList.toggle("d-none");
        document.getElementById("txt-cerrar").classList.toggle("d-none");
        document.getElementById("btnCrearEvento").classList.toggle("bg-color-cerrar");*/
        //}
    }
    function verRubrosUniones() {
        document.getElementById("containerRubros").classList.toggle("d-none");
        document.getElementById("containerUniones").classList.toggle("d-none");
        setShowUniones(!showUniones)
    }
    function mostrarFiltros() {
        props.setShowedModals(prev => [...prev, 'filters'])

        document.getElementById("containerFiltros").classList.remove("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.remove("ocultarFiltros")
    }
    return (
        <>
            <div className='row encabezadoRegistro py-4 mb-3 mb-901-0' id='encabezadoAdmin'>
                {props.seccion !== "configuracion" ?
                    <>
                        {props.seccion === "crearReunion" ? (
                            <div className='btn-buscar-admin col-md-7 col-12 pb-3 pb-md-0  pe-md-0 mobile-white col-reunion-encabezado'>
                                {eventos.length !== 0 ? (
                                    <select onChange={e => {
                                        const selectedEvento = eventos.find(ev => ev.id === e.target.value);
                                        props.setEvento(selectedEvento);
                                    }}
                                        class="form-select select-normal img-black titulos selectEncabezado fs-5 ps-0 white-space-wrap"                                         >
                                        {eventos.map(function (elem) {
                                            return (
                                                <option value={elem.id} >{elem.nombre + " " + elem.fecha}</option>
                                            )
                                        })
                                        }
                                    </select>
                                ) : (
                                    <select class="form-select bg-transparent titulos selectEncabezado fs-5 select-normal ps-0 white-space-wrap img-black "
                                        disabled>
                                        <option>No se encontraron eventos</option>
                                    </select>
                                )}
                            </div>
                        ) : (

                            <div id="botonBuscarCompleto" className={true ? 'btn-buscar-admin col-sm-8 col-12 pb-3 pb-sm-0  pe-sm-0 ' : 'col-12 col-sm pb-3 pb-sm-0 '}>

                                <div className={true ? 'rounded-boton bg-white ps-1 centrarContainer  shadowAdmin' //botonBuscarCompleto
                                    : 'rounded-boton ms-auto  bg-white ps-1 centrarContainer mb-sm-2 text-end shadowAdmin' /*botonBuscarCompleto*/}>
                                    <img className='mx-2' src={search} alt="" />
                                    <input id='buscarText' class="ps-0 form-control form-normal rounded-boton border-0 bold-botones botonBuscar d-inline-block"
                                        type="text" placeholder="Buscar" aria-label="Buscar" value={props.nombreBuscar} onChange={(e) => props.setNombreBuscar(e.target.value)} />

                                </div>

                            </div>
                        )
                        }
                        <div className='col text-end'>
                            {props.seccion === "crearReunion" &&
                                <ButtonAdmin text={'Filtrar'}
                                    isOpen={props.showedModals.includes('filters')} onClick={mostrarFiltros} className={'me-3'} />
                            }
                            {/*<button id="btnMostrarFiltros" class="btn colorPrincipal text-white bold-botones rounded-boton d-inline-block btn-cuadrado btn-blur-mobile me-3"
                                    type="submit" onClick={mostrarFiltros} >

                                    <div className='centrarContainer'>
                                        Filtrar
                                        <img className='ms-2' src={sumaBlanco} alt="" />
                                    </div>
                                </button>*/}
                            <ButtonAdmin text={props.seccion === "crearEvento" ? "Nuevo Evento" :
                                props.seccion === "crearReunion" ? "Nueva Reunión" : "Añadir Filtros"}
                                isOpen={!noShowedModals && (props.seccion !== "crearReunion" || !props.showedModals.includes('filters'))}
                                onClick={props.seccion === "crearEvento" || props.seccion === "crearReunion" ? verCrear : mostrarFiltros} />
                            {/*<button id="btnCrearEvento" class={`btn colorPrincipal text-white bold-botones rounded-boton d-inline-block btn-cuadrado btn-blur-mobile ${!noShowedModals ? 'bg-color-cerrar' : ''}`}
                                type="submit" onClick={props.seccion === "crearEvento" || props.seccion === "crearReunion" ? verCrear : mostrarFiltros} >

                                <div id="txt-nuevo-evento">
                                    <div className='centrarContainer'>

                                        {props.seccion === "crearEvento" ? "Nuevo Evento" : props.seccion === "crearReunion" ? "Nueva Reunión" : "Añadir Filtros"}
                                        <img className='ms-2' src={sumaBlanco} alt="" />
                                    </div>
                                </div>
                                <div id="txt-cerrar" className='d-none'>
                                    Cerrar
                                    <img className='ms-2 rotate-45' src={sumaBlanco} alt="" />
                                </div>
                            </button>*/}

                        </div>

                    </>
                    :
                    <>
                        <div className='col'>

                            <ButtonAdmin text={'Cambiar contraseña'} modalId={'modalCodigo'} havePlus={false} />
                            <ButtonAdmin text={showUniones ? 'Ver uniones' : 'Ver rubros'} havePlus={false} onClick={verRubrosUniones} className={'ms-4'} />
                            {/* <button id="btnCrearEvento" class="btn colorPrincipal text-white bold-botones rounded-boton d-inline-block btn-cuadrado btn-blur-mobile"
                                type="submit" data-bs-toggle="modal" data-bs-target="#modalCodigo" > Cambiar contraseña
                            </button>
                            <button id="btnCrearEvento" class="btn colorPrincipal text-white bold-botones rounded-boton d-inline-block btn-cuadrado btn-blur-mobile ms-4"
                                onClick={verRubrosUniones}>{showUniones ? 'Ver uniones' : 'Ver rubros'}
                            </button>*/}
                        </div>
                    </>
                }
            </div>

        </>
    );
}


export default EncabezadoAdminN;